<template>
 <div style="background-color: #00ccff;height: 100%;">
    <el-row class="main" :style="{height:bodyHeight, width:'80%',margin:'0 auto'}">
    <el-row class="main-top">
        <h2>北京新知堂剑桥少儿英语</h2>
    </el-row>
    <el-row class="main-middle">
        <div class="welcome-img">
        <img class="img-responsive zoom-img" :src="require('@/assets/images/128.jpg')"/>
        </div>
        <div class="welcome-img">
        <img class="img-responsive zoom-img" :src="require('@/assets/images/168.jpg')"/>
        </div>
    </el-row>
    <el-row class="main-buttom">
        <p>Copyright © 2023.北京新知堂剑桥少儿英语</p>
    </el-row>
    </el-row>
</div>
</template>
<script>
export default {
    name: '',
    data () {
        return {
          bodyHeight: 0
        }
    },
    mounted () {
        this.bodyHeight = (window.innerHeight)
    }
}
</script>
<style scoped>
.main{
    background-color: #00ccff;
}
.main-top{
    padding-top: 30px;
}
.main-top h2{
    color: #212121;
    height: 120px;
    font-size: 3em;
    text-align: center;
    vertical-align: middle;
    text-transform: uppercase;
    font-weight: 800;
    font-family: 'Catamaran', sans-serif;
    margin: 0;
}
.main-middle{
    text-align: center;
}
.main-buttom {
    position: relative;
    bottom: 0;
    width: 100%;
    height: 60px;
    line-height: 60px;
    background: #0f1215;
    text-align: center;
}
img.zoom-img {
    transform: scale(1, 1);
    -webkit-transform: scale(1, 1);
    -moz-transform: scale(1, 1);
    -ms-transform: scale(1, 1);
    -o-transform: scale(1, 1);
    transition-timing-function: ease-out;
    -webkit-transition-timing-function: ease-out;
    -moz-transition-timing-function: ease-out;
    -ms-transition-timing-function: ease-out;
    -o-transition-timing-function: ease-out;
    -webkit-transition-duration: .5s;
    -moz-transition-duration: .5s;
    -ms-transition-duration: .5s;
    -o-transition-duration: .5s;
}
img.zoom-img:hover{
     transform: scale(1.1);
     -webkit-transform: scale(1.1);
     -moz-transform: scale(1.1);
     -ms-transform: scale(1.1);
     -o-transform: scale(1.1);-webkit-transition-timing-function: ease-in-out;
     -webkit-transition-duration: 750ms;
     -moz-transition-timing-function: ease-in-out;
     -moz-transition-duration: 750ms;
     -ms-transition-timing-function: ease-in-out;
     -o-transition-timing-function: ease-in-out;
     -ms-transition-duration: 750ms;
     -o-transition-duration: 750ms;
     overflow: hidden;
}
.welcome-img {
    overflow: hidden;
    border: 8px solid #E4E4E4;
    float: left;
    width: 580px;
    height: 420px;
    margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/class/Series.vue